import React from 'react';
import HeadTittle from '../../../../../../../components/HeadTittle';
import ButtonIcon from '../../../../../../../components/buttons/ButtonIcon';
import { CleanIcon } from '../../../../../../../components/buttons/IconButtons';
import StepperTabs from '../../../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../../../components/StepperTabs/StepTab';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../../../components/buttons/ButtonNavigation';
import { STEPS_ADD_USER_DEDUCTION_POLICY } from '../../DeductionPolicy/Model/Model';
import CreateUserDeductionPolicyApp from '../Functionality/CreateUserDeductionPolicyApp';
import StepSelectUser from './StepSelectUser';
import StepDeductionEntries from './StepDeductionEntries';
import StepGlobalRules from './StepGlobalRules';
import StepUserDeductionSummary from './StepUserDeductionSummary';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Add User Deduction Policy stepper view.
 * Steps: select user → deduction entries → exclude global rules → summary.
 */
const CreateUserDeductionPolicy = () => {
    const {
        t,
        canCreate,
        steps,
        activeStep, setActiveStep,
        handleStepChange,
        emptyFields, setEmptyFields,
        handleValidateSteps,
        handleClearStep,
        handleOnBack,
        user, setUser,
        cleanChipSearch, setCleanChipSearch,
        deductions, setDeductions,
        excludedGlobalRules, setExcludedGlobalRules,
        selectForDelete, setSelectForDelete,
        searchElement, setSearchElement,
        modified, setModified,
        handleSubmit,
    } = CreateUserDeductionPolicyApp();

    return (
        <>
            <HeadTittle
                onBack={handleOnBack}
                name="create"
            />

            <StepperTabs
                id={null}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                {/* Step 1: Select user */}
                <StepTab index={STEPS_ADD_USER_DEDUCTION_POLICY.SELECT_USER.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_ADD_USER_DEDUCTION_POLICY.SELECT_USER.INDEX && (
                        <>
                            <div className="col-12 d-flex justify-content-end mb-2">
                                <ButtonIcon
                                    id="btn_cudp_clean_user"
                                    Icon={CleanIcon}
                                    onClick={() => handleClearStep(STEPS_ADD_USER_DEDUCTION_POLICY.SELECT_USER.INDEX)}
                                    title="clear_instances"
                                    className="btn-clean-secondary-600"
                                    iconProps="btn-icon-svg-12px icon-color-general-00"
                                />
                            </div>
                            <StepSelectUser
                                user={user}
                                setUser={setUser}
                                emptyFields={emptyFields}
                                cleanChipSearch={cleanChipSearch}
                                setCleanChipSearch={setCleanChipSearch}
                            />
                            <div className="col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6 mt-3">
                                <ButtonNextStep
                                    id="btn_cudp_next_user"
                                    text="next"
                                    click={() => {
                                        if (handleValidateSteps(activeStep)) {
                                            setActiveStep(prev => prev + 1);
                                        }
                                    }}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                {/* Step 2: Deduction entries */}
                <StepTab index={STEPS_ADD_USER_DEDUCTION_POLICY.DEDUCTION_POLICY.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_ADD_USER_DEDUCTION_POLICY.DEDUCTION_POLICY.INDEX && (
                        <>
                            <div className="col-12 d-flex justify-content-end mb-2">
                                <ButtonIcon
                                    id="btn_cudp_clean_deductions"
                                    Icon={CleanIcon}
                                    onClick={() => handleClearStep(STEPS_ADD_USER_DEDUCTION_POLICY.DEDUCTION_POLICY.INDEX)}
                                    title="clear_instances"
                                    className="btn-clean-secondary-600"
                                    iconProps="btn-icon-svg-12px icon-color-general-00"
                                />
                            </div>
                            <StepDeductionEntries
                                deductions={deductions}
                                setDeductions={setDeductions}
                                emptyFields={emptyFields}
                                setEmptyFields={setEmptyFields}
                            />
                            <div className="col-12 d-flex justify-content-between mt-3">
                                <ButtonPrevStep
                                    id="btn_cudp_back_deductions"
                                    text="back"
                                    click={() => setActiveStep(prev => prev - 1)}
                                />
                                <ButtonNextStep
                                    id="btn_cudp_next_deductions"
                                    text="next"
                                    click={() => {
                                        if (handleValidateSteps(activeStep)) {
                                            setActiveStep(prev => prev + 1);
                                        }
                                    }}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                {/* Step 3: Select global rules to exclude */}
                <StepTab index={STEPS_ADD_USER_DEDUCTION_POLICY.EXCLUDED_GLOBAL_DEDUCTIONS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_ADD_USER_DEDUCTION_POLICY.EXCLUDED_GLOBAL_DEDUCTIONS.INDEX && (
                        <>
                            <div className="col-12 d-flex justify-content-end mb-2">
                                <ButtonIcon
                                    id="btn_cudp_clean_global_deductions"
                                    Icon={CleanIcon}
                                    onClick={() => handleClearStep(STEPS_ADD_USER_DEDUCTION_POLICY.EXCLUDED_GLOBAL_DEDUCTIONS.INDEX)}
                                    title="clear_instances"
                                    className="btn-clean-secondary-600"
                                    iconProps="btn-icon-svg-12px icon-color-general-00"
                                />
                            </div>
                            <StepGlobalRules
                                excludedGlobalRules={excludedGlobalRules}
                                setExcludedGlobalRules={setExcludedGlobalRules}
                                selectForDelete={selectForDelete}
                                setSelectForDelete={setSelectForDelete}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                modified={modified}
                                setModified={setModified}
                            />
                            <div className="col-12 d-flex justify-content-between mt-3">
                                <ButtonPrevStep
                                    id="btn_cudp_back_global_deductions"
                                    text="back"
                                    click={() => setActiveStep(prev => prev - 1)}
                                />
                                <ButtonNextStep
                                    id="btn_cudp_next_global_deductions"
                                    text="next"
                                    click={() => setActiveStep(prev => prev + 1)}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                {/* Step 4: Summary */}
                <StepTab index={STEPS_ADD_USER_DEDUCTION_POLICY.SUMMARY.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_ADD_USER_DEDUCTION_POLICY.SUMMARY.INDEX && (
                        <>
                            <StepUserDeductionSummary
                                user={user}
                                deductions={deductions}
                                excludedGlobalRules={excludedGlobalRules}
                            />
                            <div className="d-flex justify-content-between px-0 mb-2 mt-3">
                                <ButtonPrevStep
                                    id="btn_cudp_back_summary"
                                    text="back"
                                    click={() => setActiveStep(prev => prev - 1)}
                                />
                                {(canCreate) && (
                                    <ButtonNextStep
                                        id="btn_cudp_create"
                                        text={'create'}
                                        click={handleSubmit}
                                    />
                                )}
                            </div>
                        </>
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
};

export default CreateUserDeductionPolicy;
